import styled from 'styled-components'

export const Absolute = styled.div`
  position: absolute;
`

export const MoreMenu = styled.div`
  margin-right: 1.5rem;
`
